import { apiJson, buildApiUrl } from "./client";

export function getMatches(query) {
  return apiJson("/api/Matches", { method: "GET", query });
}

export function getMatchById(id) {
  return apiJson(`/api/Matches/${id}`, { method: "GET" });
}

export function createMatch(dto) {
  return apiJson("/api/Matches", { method: "POST", body: dto });
}

export function bookMatch(id, dto = {}) {
  return apiJson(`/api/Matches/${id}/book`, { method: "POST", body: dto });
}

export function cancelMatch(id, query) {
  return apiJson(`/api/Matches/${id}/cancel`, { method: "POST", query });
}

export function getMyBookings() {
  return apiJson("/api/Matches/my-bookings", { method: "GET" });
}

/** Host-only after match end; cookie auth. */
export async function uploadMatchTeamPhoto(matchId, file) {
  const form = new FormData();
  form.append("file", file);
  const response = await fetch(buildApiUrl(`/api/Matches/${matchId}/team-photo`), {
    method: "POST",
    credentials: "include",
    headers: { "X-WillPlay-Request": "1" },
    body: form
  });
  const text = await response.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }
  }
  return { response, data };
}

export function deleteMatchTeamPhoto(matchId) {
  return apiJson(`/api/Matches/${matchId}/team-photo`, { method: "DELETE", auth: true });
}